// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';

/**
 * @autodoc apply FsmAction
 */
class ResumeAnimationAction extends Action {
  enter(fsm) {
    if (this.onAll) {
      const world = fsm.getWorld();
      const animationSystem = world.getSystem('AnimationSystem');
      animationSystem.resume();
    } else {
      const entity = fsm.getOwnerEntity();
      if (entity.animationComponent) {
        entity.animationComponent.resume();
      }
    }
  }
}

ResumeAnimationAction.external = {
  key: 'ResumeAnimation',
  deprecatedKey: 'Resume Animation',
  name: 'Resume Animation',
  type: 'animation',
  description: "Continues playing a skeleton animation in the Animation Asset used on the behavior's Animation Component.",
  parameters: [{
    name: 'On all entities',
    key: 'onAll',
    type: 'boolean',
    description: 'Resume animation on all entities or just one.',
    default: false,
  }],
  transitions: [],
};

ResumeAnimationAction.register();

export default ResumeAnimationAction;
